import { Plus } from "lucide-react";
import { FAQS } from "@/content/chapters";
import { Reveal, SectionHeading } from "@/components/motifs";

// The same questions are published as FAQPage structured data on /mithila-art.
export const FaqSection = () => (
  <section id="questions" className="paper-surface border-y border-border" data-testid="faq-section">
    <div className="mx-auto max-w-7xl px-5 py-24 sm:px-8 sm:py-32">
      <SectionHeading number="FAQ" title="Questions About Mithila Art" note="Asked often, answered plainly" />
      <Reveal className="mx-auto max-w-3xl divide-y divide-border border-y border-border">
        {FAQS.map((f, i) => (
          <details key={f.q} className="group py-6" data-testid={`faq-item-${i}`}>
            <summary className="flex cursor-pointer list-none items-start justify-between gap-6 [&::-webkit-details-marker]:hidden">
              <h3 className="font-serif text-xl font-medium tracking-tight transition-colors group-hover:text-accent sm:text-2xl">{f.q}</h3>
              <Plus
                size={18}
                className="mt-1.5 shrink-0 text-muted-foreground transition-transform duration-300 group-open:rotate-45 group-open:text-accent"
              />
            </summary>
            <p className="mt-4 max-w-2xl text-sm leading-relaxed text-muted-foreground sm:text-base">{f.a}</p>
          </details>
        ))}
      </Reveal>
    </div>
  </section>
);
